import request from "@/utils/request";

export function getOpenPositionv2(params) {
  return request({
    url: "/trades/v2",
    method: "get",
    params
  });
}

export function getOpenPosition(params) {
  return request({
    url: "/trades",
    method: "get",
    params
  });
}


export function getBalanceInformation(login) {
  return request({
    url: "/users/" + login,
    method: "get"
  });
}

export function getUsers() {
  return request({
    url: "/users",
    method: "get"
  });
}

export function getWatchList() {
  return request({
    url: "/trades/watch_list",
    method: "get"
  });
}


export function addWatchList(data) {
  return request({
    url: "/trades/watch_list",
    method: "post",
    data
  });
}

export function removeWatchList(login) {
  return request({
    url: "/trades/watch_list/"+login,
    method: "delete"
  });
}

export function updateUser(login, data) {
  return request({
    url: "/users/" + login,
    method: "put",
    data
  });
}

export function getNvtHedge() {
  return request({
    url: "/trades/nvt/hedge",
    method: "get"
  });
}

export function download(type = "login") {
  return request({
    url: "/trades/download?type="+type,
    method: "post"
  }, {
    responseType: 'blob'
  });
}

export function getPosition(params) {
  return request({
    url: "/trades/v2/position",
    method: "get",
    params
  });
}

export function getSymbol() {
  return request({
    url:  "/trades/v2/symbols",
    method: "get"
  });
}

export function getWatchSymbol() {
  return request({
    url:  "/trades/v2/watch/position_symbol",
    method: "get"
  });
}

export function addWatchSymbol(data) {
  return request({
    url:  "/trades/v2/watch/position_symbol",
    method: "post",
    data
  });
}

export function deleteWatchSymbol(symbol) {
  return request({
    url:  "/trades/v2/watch/position_symbol/"+symbol,
    method: "delete"
  });
}


